const freeGiftActive = localStorage.getItem('showOfferBanner');
let fetchSection = 'cart-section';
if (typeof cartSections !== 'undefined') {
    fetchSection = cartSections;
}
const debounce = (callback, wait) => {
    let timeoutId = null;
    return (...args) => {
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(() => {
            callback(...args);
        }, wait);
    };
}

function _onQuantityInputChange(event, id, price) {
    const input = event.target;
    const oldQty = parseInt(input.getAttribute('data-qty'));
    if (!event.target.value) {
        event.target.value = oldQty;
    }
}


function _onQuantityKeyUp(event, id, price) {
    const input = event.target;
    const row = document.getElementById(id);
    const oldQty = parseInt(input.getAttribute('data-qty'));
    if (event.target.value.length && event.target.value == 0) {
        event.target.value = oldQty;
        return;
    }
    if (event.target.value) {
        console.log(isNaN(event.target.value), event.target.value);
        _updateQty(input, id, event.target.value, oldQty, row, price);

    }
}

const onQuantityKeyUp = debounce(_onQuantityKeyUp, 500);
const onQuantityInputChange = debounce(_onQuantityInputChange, 500);

async function updateQuantity(id, price, subtract = false) {
    toggleBusy(id);
    const input = document.getElementById('Quantity-' + id);
    let qty = parseInt(input.value);
    const oldQty = parseInt(input.getAttribute('data-qty'));
    if (subtract) {
        qty--;
    } else {
        vwoAddToCart();
        qty++;
    }
    if (qty < 1) {
        qty = 1;
    }

    const row = document.getElementById(id);
    input.value = qty;
    input.setAttribute('data-qty', qty);

    updateCartBadge(qty - oldQty);

    console.log(qty, oldQty);
    if (qty === 1 && qty === oldQty) {
        toggleBusy(id);
        return;
    }
    return _updateQty(input, id, qty, oldQty, row, price);
}


function vwoAddToCart() {
    window.VWO = window.VWO || [];
    VWO.event = VWO.event || function () {
        VWO.push(["event"].concat([].slice.call(arguments)))
    };

    // Replace the property values with your actual values
    VWO.event("addToCart", {
        "product": 1
    });
}

function _updateQty(input, id, qty, oldQty, row, price) {
    row.classList.add('active');

    const data = {
        updates: {
            [id]: qty,
        }, sections: fetchSection,
    }


    return fetch('/cart/update.js', {
        method: 'POST', headers: {
            'Content-Type': 'application/json'
        }, body: JSON.stringify(data)
    }).then(async (response) => {
        if (typeof isWholeSale !== 'undefined') {
            location.reload();
            return;
        }
        const discountedItemCart = await processDiscountData();
        const body = await response.json();
        if (discountedItemCart) {
            updateCartData(discountedItemCart);
        } else {
            updateCartData(body);
        }
        // addDiscountProduct();
        row.classList.remove('active');
        return response;
    }).catch((error) => {
        console.log(error);
        toggleBusy(id);
        input.value = oldQty;
        alert('An error occurred while processing your request. Please try again later.');
        row.classList.remove('active');
        return error;
    });
}

async function processDiscountData() {
    return;
    const req = await fetch('/cart.js', {
        headers: {
            'Content-Type': 'application/json'
        },
    });
    const res = await req.json();
    const hasItemAdded = res.items.find((item) => {
        return item.properties?._tired_free_efa && !item.selling_plan_allocation;
    });
    let total = res.total_price;
    if (hasItemAdded) {
        total = total - (hasItemAdded.final_line_price / hasItemAdded.quantity);
    }
    console.log(total);
    if (total >= 100 * 100) {
        if (!hasItemAdded) {
            const req = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    items: [{
                        "id": 31283306102895,
                        "quantity": 1,
                        "properties": {
                            "_tired_free_efa": true,
                        }
                    }],
                    sections: 'cart-section',
                })
            });
            return await req.json();
        }
    } else {
        if (hasItemAdded) {
            const req = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: hasItemAdded.key,
                    quantity: 0,
                    sections: 'cart-section',
                })
            });
            return await req.json();
        }
    }
    console.log(res);
}


async function addDiscountProduct() {
    console.log('calculating');
    let cartTotal = 0;
    document.querySelectorAll('#cart-header-container .cart-item-total .cart-item-total').forEach((i) => {
        cartTotal += +i.textContent.replace('$', '');
    });
    const discountAdded = document.querySelector('.item-container.discounted');
    console.log('calculating 2', freeGiftActive, cartTotal, discountAdded);
    if (freeGiftActive && cartTotal >= 50 && !discountAdded) {
        document.querySelector('.free-offer-msg').classList.add('show');
        fetch('/cart/add.js', {
            method: 'POST', headers: {
                'Content-Type': 'application/json'
            }, body: JSON.stringify({
                items: [{
                    "id": 41107161219183, "quantity": 1
                }], sections: fetchSection,
            })
        }).then(async () => {
            setTimeout(() => {
                fetch('/?section_id=cart-section', {
                    method: 'GET', headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(async (response) => {
                    const body = await response.text();
                    console.log('calculating 4');
                    document.getElementById('cart-header-container').innerHTML = body;
                    updateCartBadge(1);
                }).catch((error) => {
                    console.log(error);
                    alert('An error occurred while processing your request. Please try again later.');
                });
            }, 500);
        }).catch((error) => {
            console.log(error);
            alert('An error occurred while processing your request. Please try again later.');
        });

    }
}


async function deleteItem(key, productId) {
    toggleBusy(key);
    const input = document.getElementById('Quantity-' + key);

    const qty = +input.getAttribute('data-qty');
    updateCartBadge(-qty);

    const data = {
        updates: {
            [key]: 0,
        }, sections: fetchSection,
    }


    updatedAddedProducts(productId);
    fetch('/cart/update.js', {
        method: 'POST', headers: {
            'Content-Type': 'application/json'
        }, body: JSON.stringify(data)
    }).then(async response => {
        if (typeof isWholeSale !== 'undefined') {
            location.reload();
            return;
        }
        const discountedItemCart = await processDiscountData();
        toggleBusy(key);
        const body = await response.json();
        console.log(body);
        if (discountedItemCart) {
            updateCartData(discountedItemCart);
        } else {
            updateCartData(body);
        }
        cartProcessing = false;
    }).catch((error) => {
        console.log(error);
        updateCartBadge(qty);
        console.log(document.getElementById('cart-trigger'));
        cartProcessing = false;
        toggleBusy(key);
        alert('An error occurred while processing your request. Please try again later.');
    });

}


function updateCartBadge(quantity, noToggle=false) {
    const cart = document.querySelector('.cart-count');
    const badge = +cart.textContent || 0;
    cart.textContent = (+badge) + quantity;
    if(!noToggle) {
        document.getElementById('cart-container')?.classList?.add('active');
        toggleBodyOverflow();
    }
}

function toggleBodyOverflow(){
    if(window.innerWidth <= 767){
        document.body.classList.toggle('stay-fixed');
        document.documentElement.classList.toggle('stay-fixed');
    }
}

function upgradeItem(key, quantity, selling_plan = null) {
    console.log('upgradeItem', key, quantity, selling_plan);
    toggleBusy(key);
    const data = {
        id: key, quantity, selling_plan, sections: fetchSection,
    }

    const row = document.getElementById(key);
    row.classList.add('active');

    return fetch('/cart/change.js', {
        method: 'POST', headers: {
            'Content-Type': 'application/json'
        }, body: JSON.stringify(data)
    }).then(async (response) => {
        if (typeof isWholeSale !== 'undefined') {
            location.reload();
            return;
        }

        const body = await response.json();
        console.log('awaiting');
        const discountedItemCart = await processDiscountData();
        console.log('done');
        if (discountedItemCart) {
            updateCartData(discountedItemCart);
        } else {
            updateCartData(body);
        }
        row.classList.remove('active');
        return response;
    }).catch((error) => {
        toggleBusy(key);
        console.log(error);
        // input.value = oldQty;
        alert('An error occurred while processing your request. Please try again later.');
        row.classList.remove('active');
        return error;
    });


}


function updateCartData(data) {
    if (typeof cartContainer == 'undefined') {
        document.querySelector('.sidebar-cart').innerHTML = data.sections[fetchSection];
    } else {
        document.querySelector(cartContainer).innerHTML = data.sections[fetchSection];
    }
    // document.getElementById('cart-items-count').textContent = data.item_count;
}

function toggleBusy(key) {
    document.getElementById(key).classList.toggle('active');
}


async function loadRecommendations(productId) {
    return;
    console.log('loading recommendations null');
    if (!productId) return;
    console.log('loading recommendations', productId);
    const req = await fetch('/recommendations/products.json?product_id=' + productId + '&intent=complementary');
    const products = (await req.json()).products;
    console.log(products);
    let productMarkup = '<h3>Customers Also Purchased</h3><div id="recommendation-cards">';
    products?.forEach((product) => {
        if (!addedProducts.includes(product.id)) {
            productMarkup += relatedProductMarkup(product);
        }
    });
    productMarkup += '</div>';
    // document.getElementById('cart-recommendations').innerHTML = productMarkup;
}

function updatedAddedProducts(productId) {
    try {
        if (!addedProducts.includes(productId)) {
            addedProducts.push(productId);
            relatedProductId = productId;
            loadRecommendations(relatedProductId);
        } else {
            addedProducts = addedProducts.filter((id) => id !== productId);
            if (addedProducts.length > 0) {
                relatedProductId = addedProducts[addedProducts.length - 1];
                loadRecommendations(relatedProductId);
            } else {
                // document.getElementById('cart-recommendations').innerHTML = '';
            }
        }
    } catch (e) {
        console.log(e);
    }
}


function relatedProductMarkup(product) {
    return `
    <div class="related-item" onclick="addToCartRelated(${product.variants[0].id}, ${product.id})">
        <div class="add-related">+</div>
        <div class="related-img"><img src="${product.images[0]}"></div>
        <div>
          <h4>${truncateString(product.title)}</h4>
          <p class="related-price">$${product.price / 100}</p>
        </div>
    </div>
    
    `;
    // <p class="related-variant" >${product.variants[0].title} < /p>

}

async function addToCartRelated(variantId, productId) {
    updatedAddedProducts(productId);
    const data = {
        items: [{
            "id": variantId, "quantity": 1
        }], sections: fetchSection,
    };
    fetch('/cart/add.js', {
        method: 'POST', headers: {
            'Content-Type': 'application/json'
        }, body: JSON.stringify(data)
    }).then(async (response) => {
        if (typeof isWholeSale !== 'undefined') {
            location.reload();
            return;
        }

        const body = await response.json();
        console.log(body);

        document.getElementById('cart-header-container').innerHTML = body.sections[fetchSection];
        updateCartBadge(1);
    }).catch((error) => {
        alert('An error occurred while processing your request. Please try again later.');
    });

}


function truncateString(str) {
    if (str.length > 35) {
        return str.slice(0, 35) + "...";
    } else {
        return str;
    }
}

loadRecommendations(relatedProductId);

async function clearCart(force = true) {
    if (!force && cleared) return;

    cleared = false;
    await fetch('/cart/clear.js', {
        method: 'POST', headers: {
            'Content-Type': 'application/json'
        }, body: JSON.stringify('') // for no data you can omit the body or pass an empty object
    })
        .then(response => response.json())
        .then(data => {
            processing = false;
            cleared = true;
        })
        .catch((error) => {
            processing = false;
        });

}


document.getElementById('cart-trigger').addEventListener('click', (e) => {
    e.preventDefault();
    console.log('clicked');
    if (location.pathname === '/cart') {
        location.href = '/cart';
    } else {
        document.getElementById('cart-container').classList.toggle('active');
        toggleBodyOverflow()
    }
});

function toggleSidebarCart() {
    document.getElementById('cart-container').classList.toggle('active');
    toggleBodyOverflow()
}

document.getElementById('cart-backdrop')?.addEventListener('click', () => {
    document.getElementById('cart-container').classList.toggle('active');
    toggleBodyOverflow()
})

